import {  Injectable } from '@angular/core';
import { AngularFireStorage} from '@angular/fire/storage';
import { Observable } from "rxjs";
import { Directorio } from "../modelos/directorio.model";
import { map } from 'rxjs/operators';
import { AngularFirestore } from '@angular/fire/firestore';

@Injectable()
export class pdfViewService{
    constructor(private storage:AngularFireStorage,
      private db: AngularFirestore){

    }

     //Obtiene Pdf info
     getPdf(): Observable<Directorio[]> {
      return this.db.collection<Directorio>('directorio').snapshotChanges().pipe(
          map(actions => actions.filter((a) => {
              return a.payload.doc.data();
          }).map(a => {
              const _data = a.payload.doc.data();
              const id = a.payload.doc.id;

              // set Data interfas
              const data: Directorio = {
                  key: id,
                  nombre: _data.nombre,
                  descripcion: _data.descripcion,
                  urlPdf: _data.urlPdf
              };
              return data;
          }))
      );
  }
}